import { FC, MouseEvent } from "react";
import "./ListItem.css";
import { useNavigate } from "react-router-dom";
import type { IUser } from "../../../redux/types/UserTypes";
import { deleteUser } from "../../../redux/requests/UserRequests";
import { useAppDispatch } from "../../../hooks/ReduxHooks";

interface IUserItemProps {
  user: IUser;
  checkboxVisible?: boolean;
    checked?: boolean;
  onCheckChange?: (id: string, checked: boolean) => void;
}

const UserItem: FC<IUserItemProps> = ({ user, checkboxVisible=false, onCheckChange, checked }) => {
  const navigation = useNavigate();
  const dispatch = useAppDispatch();


  const onEditClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    navigation(`user-edit/${user.id}`);
  };

  const onDeleteClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();                                                                                                                                                  
    dispatch(deleteUser(user.id));
  };



  return (
    <li className="flex flex-row items-center justify-between gap-10 border-b py-2">
      <span>{user.name}</span>
      <span>{user.phone}</span>

      {checkboxVisible && (
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onCheckChange?.(user.id, e.target.checked)}
        />
      )}
      {!checkboxVisible && (
        <div className="operator-actions">
          <button className="view-stats-btn" onClick={onEditClick}>
            Редактировать
          </button>
          <button className="view-stats-btn" onClick={onDeleteClick}>
            Удалить
          </button>
        </div>
      )}
    </li>
  );
};

export default UserItem;
